<script>
	export default {
		name: 'StateExecuter',
		methods: {
			getAdminState(key) {
				const self_ = this;
				const state_ = self_.getState('admin')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getAppState(key) {
				const self_ = this;
				const state_ = self_.getState('app')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getComponentState(key) {
				const self_ = this;
				const state_ = self_.getState('component')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getContentsState(key) {
				const self_ = this;
				const state_ = self_.getState('contents')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getDebugState(key) {
				const self_ = this;
				const state_ = self_.getState('debug')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getInitsState(key) {
				const self_ = this;
				const state_ = self_.getState('inits')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getInputState(key) {
				const self_ = this;
				const state_ = self_.getState('input')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getLangsState(key) {
				const self_ = this;
				const state_ = self_.getState('langs')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getMessageState(key) {
				const self_ = this;
				const state_ = self_.getState('message')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getPageState(key) {
				const self_ = this;
				const state_ = self_.getState('page')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getPointState(key) {
				const self_ = this;
				const state_ = self_.getState('point')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getRecruitmentsState(key) {
				const self_ = this;
				const state_ = self_.getState('recruitments')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getSalesState(key) {
				const self_ = this;
				const state_ = self_.getState('sales')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getStylesState(key) {
				const self_ = this;
				const state_ = self_.getState('styles')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getTrainingsState(key) {
				const self_ = this;
				const state_ = self_.getState('trainings')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getUserState(key) {
				const self_ = this;
				const state_ = self_.getState('user')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			getVersionInfoState(key) {
				const self_ = this;
				const state_ = self_.getState('versionInfo')
				const result_ = self_.parseObject(state_)
				if(self_.isEmpty(key)) { return result_ }
				else { return result_[key] }
			},
			setAdminState(key, value) {
				const self_ = this;
				self_.commitSetValue('admin', key, value)
			},
			setAppState(key, value) {
				const self_ = this;
				self_.commitSetValue('app', key, value)
			},
			setComponentState(key, value) {
				const self_ = this;
				self_.commitSetValue('component', key, value)
			},
			setContentsState(key, subKey, value) {
				const self_ = this;
				self_.commitSetSubValue('contents', key, subKey, value)
			},
			setDebugState(key, value) {
				const self_ = this;
				self_.commitSetValue('debug', key, value)
			},
			setInitsState(key, subKey, value) {
				const self_ = this;
				self_.commitSetSubValue('inits', key, subKey, value)
			},
			setInputState(key, value) {
				const self_ = this;
				self_.commitSetValue('input', key, value)
			},
			setMessageState(key, value) {
				const self_ = this;
				self_.commitSetValue('message', key, value)
			},
			setPageState(key, value) {
				const self_ = this;
				self_.commitSetValue('page', key, value)
			},
			setPointState(key, value) {
				const self_ = this;
				self_.commitSetValue('point', key, value)
			},
			setRecruitmentsState(key, value) {
				const self_ = this;
				self_.commitSetValue('recruitments', key, value)
			},
			setSalesState(key, value) {
				const self_ = this;
				self_.commitSetValue('sales', key, value)
			},
			setTrainingsState(key, value) {
				const self_ = this;
				self_.commitSetValue('trainings', key, value)
			},
			setUserState(key, value) {
				const self_ = this;
				self_.commitSetValue('user', key, value)
			},
			setVersionInfoState(key, value) {
				const self_ = this;
				self_.commitSetValue('versionInfo', key, value)
			},
			getState(target) {
				const self_ = this;
				const store_ = self_.$store;
				return store_.getters[target + '/get']
			},
			commitSetValue(target, key, value) {
				const self_ = this;
				const store_ = self_.$store;
				store_.commit(target + '/setValue', [key, value])
			},
			commitSetSubValue(target, key, subKey, value) {
				const self_ = this;
				const store_ = self_.$store;
				store_.commit(target + '/setSubValue', [key, subKey, value])
			}
		}
	}
</script>